module.exports = __webpack_public_path__ + "img/hp6.ade61f31.png";